var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTryFreeTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 47.9998C64 56.8397 56.84 63.9997 48 63.9997C48 55.1597 55.16 47.9998 64 47.9998Z",
    fill: "#FFCB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0006 41.5999V47.9998C55.1606 47.9998 48.0006 55.1598 48.0006 63.9998H41.6006C41.6006 51.6398 51.6406 41.5999 64.0006 41.5999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0006 35.2V41.5999C58.9606 41.5999 54.0806 40.6799 49.6006 39.0399C53.8406 36.5999 58.7606 35.2 64.0006 35.2Z",
    fill: "#001A21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0003 28.8V35.2C58.7603 35.2 53.8003 34.04 49.3203 32C53.8003 29.96 58.7603 28.8 64.0003 28.8Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0006 22.4001V28.8001C58.7606 28.8001 53.8406 27.4001 49.6006 24.9601C54.0806 23.3201 58.9606 22.4001 64.0006 22.4001Z",
    fill: "#001A21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0006 16V22.4C51.6406 22.4 41.6006 12.36 41.6006 0H48.0006C48.0006 8.83999 55.1606 16 64.0006 16Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48 0C56.84 0 64 7.15999 64 16C55.16 16 48 8.83999 48 0Z",
    fill: "#00F2F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.001 22.4C58.961 22.4 54.081 23.32 49.601 24.96C45.201 22.44 41.561 18.76 39.041 14.4C40.681 9.91999 41.601 5.07999 41.601 0C41.601 12.36 51.641 22.4 64.001 22.4Z",
    fill: "#00F2F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.601 39.0393C54.081 40.6793 58.921 41.5993 64.001 41.5993C51.641 41.5993 41.601 51.6393 41.601 63.9993C41.601 58.9593 40.681 54.0793 39.041 49.5993C41.601 45.2393 45.241 41.5593 49.601 39.0393Z",
    fill: "#FFCB00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 28.8004C58.7599 28.8004 53.7999 29.9604 49.3199 32.0004C47.0399 30.9604 44.8799 29.6404 42.8799 28.1604C44.9999 26.8804 47.2799 25.8404 49.5999 24.9604C53.8399 27.4004 58.7599 28.8004 63.9999 28.8004Z",
    fill: "#FFCB00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3199 32C53.7999 34.04 58.7599 35.2 63.9999 35.2C58.7599 35.2 53.8399 36.6 49.5999 39.04C47.2399 38.16 44.9999 37.12 42.8799 35.84C44.8799 34.32 47.0399 33.04 49.3199 32Z",
    fill: "#00F2F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0418 14.4001C41.5618 18.8001 45.2418 22.4401 49.6018 24.9601C47.2418 25.8401 45.0018 26.9201 42.8818 28.1601C40.2018 26.1601 37.8418 23.8001 35.8418 21.1201C37.1218 19.0001 38.1618 16.7201 39.0418 14.4001Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6018 39.0394C45.2018 41.5593 41.5618 45.2393 39.0418 49.5993C38.1618 47.2393 37.0818 44.9993 35.8418 42.8793C37.8418 40.1994 40.2018 37.8394 42.8818 35.8394C45.0018 37.1194 47.2818 38.1594 49.6018 39.0394Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8794 28.1604C44.8794 29.6804 47.0394 30.9604 49.3194 32.0004C47.0394 33.0404 44.8794 34.3204 42.8794 35.8404C40.9594 34.7204 39.1194 33.4004 37.3994 32.0004C39.1194 30.5604 40.9594 29.2804 42.8794 28.1604Z",
    fill: "#001A21"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6002 63.9998H35.2002C35.2002 58.7598 36.6002 53.8398 39.0402 49.5999C40.6802 54.0798 41.6002 58.9198 41.6002 63.9998Z",
    fill: "#001A21"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6002 0C41.6002 5.03999 40.6802 9.91999 39.0402 14.4C36.6002 10.16 35.2002 5.23999 35.2002 0H41.6002Z",
    fill: "#001A21"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.84 21.1196C37.84 23.7996 40.2 26.1596 42.88 28.1596C40.96 29.2796 39.12 30.5996 37.4 31.9996C35.44 30.3596 33.6 28.5596 32 26.5596C33.44 24.8796 34.72 23.0396 35.84 21.1196Z",
    fill: "#00F2F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.88 35.8393C40.2 37.8393 37.84 40.1993 35.84 42.8793C34.72 40.9593 33.4 39.1193 32 37.4393C33.64 35.4793 35.44 33.6393 37.4 32.0393C39.12 33.3993 40.96 34.7193 42.88 35.8393Z",
    fill: "#FFCB00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 0C35.2 5.23999 36.6 10.16 39.04 14.4C38.16 16.76 37.08 19 35.84 21.12C34.32 19.12 33.04 16.96 32 14.68C34.04 10.2 35.2 5.23999 35.2 0Z",
    fill: "#FFCB00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.04 49.6001C36.6 53.8401 35.2 58.7601 35.2 64.0001C35.2 58.7601 34.04 53.8001 32 49.3201C33.04 47.0401 34.36 44.8801 35.84 42.8801C37.12 45.0001 38.16 47.2401 39.04 49.6001Z",
    fill: "#00F2F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7998 0H35.1998C35.1998 5.23999 34.0398 10.2 31.9998 14.68C29.9598 10.2 28.7998 5.23999 28.7998 0Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1998 63.9998H28.7998C28.7998 58.7598 29.9598 53.7998 31.9998 49.3198C34.0398 53.7998 35.1998 58.7598 35.1998 63.9998Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0006 37.4405C34.9829 37.4405 37.4006 35.005 37.4006 32.0005C37.4006 28.9961 34.9829 26.5605 32.0006 26.5605C29.0182 26.5605 26.6006 28.9961 26.6006 32.0005C26.6006 35.005 29.0182 37.4405 32.0006 37.4405Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8372 21.1199C34.7172 23.0399 33.3972 24.8799 31.9972 26.5599C30.5572 24.8399 29.2772 23.0399 28.1572 21.1199C29.6772 19.1199 30.9572 16.9599 31.9972 14.6799C33.0372 16.9599 34.3572 19.1199 35.8372 21.1199Z",
    fill: "#001A21"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9972 37.4001C33.4372 39.1201 34.7172 40.9201 35.8372 42.8401C34.3172 44.8401 33.0372 47.0001 31.9972 49.2801C30.9572 47.0001 29.6372 44.8401 28.1572 42.8401C29.2772 40.9601 30.5572 39.1201 31.9972 37.4001Z",
    fill: "#001A21"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.798 0C28.798 5.23999 29.958 10.2 31.998 14.68C30.958 16.96 29.638 19.12 28.158 21.12C26.918 19 25.838 16.72 24.958 14.4C27.398 10.16 28.798 5.23999 28.798 0Z",
    fill: "#00F2F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.998 49.3201C29.958 53.8001 28.798 58.7601 28.798 64.0001C28.798 58.7601 27.398 53.8401 24.958 49.6001C25.838 47.2401 26.918 45.0001 28.158 42.8801C29.638 44.8801 30.958 47.0401 31.998 49.3201Z",
    fill: "#FFCB00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7994 63.9998H22.3994C22.3994 58.9598 23.3194 54.0798 24.9594 49.5999C27.3994 53.8398 28.7994 58.7598 28.7994 63.9998Z",
    fill: "#001A21"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7994 0C28.7994 5.23999 27.3994 10.16 24.9594 14.4C23.3194 9.91999 22.3994 5.03999 22.3994 0H28.7994Z",
    fill: "#001A21"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1572 21.1196C29.2772 23.0396 30.5972 24.8796 31.9972 26.5596C30.3572 28.5196 28.5572 30.3596 26.5972 31.9996C24.8772 30.5596 23.0772 29.2796 21.1572 28.1596C23.7972 26.1596 26.1572 23.7996 28.1572 21.1196Z",
    fill: "#FFCB00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9991 37.4004C30.5591 39.1204 29.2791 40.9204 28.1591 42.8404C26.1591 40.1604 23.7991 37.8004 21.1191 35.8004C23.0391 34.6804 24.8791 33.3604 26.5591 31.9604C28.5591 33.6404 30.3591 35.4404 31.9991 37.4004Z",
    fill: "#00F2F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1574 21.1201C26.1574 23.8001 23.7974 26.1601 21.1174 28.1601C18.9974 26.8801 16.7174 25.8401 14.3574 24.9601C18.7574 22.4401 22.3974 18.7601 24.9174 14.4001C25.8374 16.7201 26.9174 19.0001 28.1574 21.1201Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1194 35.8394C23.7994 37.8394 26.1594 40.1994 28.1594 42.8793C26.9194 44.9993 25.8394 47.2793 24.9594 49.5993C22.4394 45.1993 18.7594 41.5593 14.3994 39.0394C16.7594 38.1594 18.9994 37.1194 21.1194 35.8394Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 0C22.4 5.03999 23.32 9.91999 24.96 14.4C22.44 18.8 18.76 22.44 14.4 24.96C9.91999 23.32 5.03999 22.4 0 22.4C12.36 22.4 22.4 12.36 22.4 0Z",
    fill: "#FFCB00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24.96 49.5993C23.32 54.0793 22.4 58.9193 22.4 63.9993C22.4 51.6393 12.36 41.5993 0 41.5993C5.03999 41.5993 9.91999 40.6793 14.4 39.0393C18.76 41.5593 22.44 45.2393 24.96 49.5993Z",
    fill: "#00F2F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H22.4C22.4 12.36 12.36 22.4 0 22.4V16C8.83999 16 16 8.83999 16 0Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 63.9998H16C16 55.1598 8.83999 47.9998 0 47.9998V41.5999C12.36 41.5999 22.4 51.6398 22.4 63.9998Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1197 28.1604C23.0397 29.2804 24.8797 30.6004 26.5597 32.0004C24.8397 33.4004 23.0397 34.7204 21.1197 35.8404C19.1197 34.3204 16.9597 33.0404 14.6797 32.0004C16.9597 30.9604 19.1197 29.6404 21.1197 28.1604Z",
    fill: "#001A21"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21.12 28.1604C19.12 29.6404 16.96 30.9604 14.68 32.0004C10.2 29.9604 5.23999 28.8004 0 28.8004C5.23999 28.8004 10.16 27.4004 14.4 24.9604C16.76 25.8004 19 26.8804 21.12 28.1604Z",
    fill: "#00F2F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14.68 32C16.96 33.04 19.12 34.32 21.12 35.84C19 37.12 16.72 38.16 14.36 39.04C10.16 36.6 5.23999 35.2 0 35.2C5.23999 35.2 10.2 34.04 14.68 32Z",
    fill: "#FFCB00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C16 8.83999 8.83999 16 0 16C0 7.15999 7.15999 0 16 0Z",
    fill: "#FFCB00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.9998C8.83999 47.9998 16 55.1597 16 63.9997C7.15999 63.9997 0 56.8397 0 47.9998Z",
    fill: "#00F2F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.8C5.23999 28.8 10.2 29.96 14.68 32C10.2 34.04 5.23999 35.2 0 35.2V28.8Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 24.9601C10.16 27.4001 5.23999 28.8001 0 28.8001V22.4001C5.03999 22.4001 9.91999 23.3201 14.4 24.9601Z",
    fill: "#001A21"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.2C5.23999 35.2 10.16 36.5999 14.4 39.0399C9.91999 40.6799 5.07999 41.5999 0 41.5999V35.2Z",
    fill: "#001A21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryFreeTool);
export default __webpack_public_path__ + "static/media/try_free_tool.0c23097df9ee6947c92b2692cc4c4263.svg";
export { ForwardRef as ReactComponent };